
export const common = {
  // Navigation
  home: 'Inicio',
  plans: 'Planes',
  wallet: 'Billetera',
  rewards: 'Recompensas',
  profile: 'Perfil',
  
  // Common actions
  subscribe: 'Suscribirse',
  claim: 'Reclamar',
  withdraw: 'Retirar',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',
  continue: 'Continuar',
  back: 'Atrás',
  next: 'Siguiente',
  confirm: 'Confirmar',
  
  // Home page
  welcomeBack: 'Bienvenido de vuelta',
  earnRewards: 'Gana recompensas probando deliciosas comidas hoy',
  subscribeToStart: 'Suscríbete a un plan y comienza a ganar recompensas',
  availableMeals: 'Comidas Disponibles',
  rewardsLeft: 'recompensas restantes',
  
  // Dulce Commercio section
  dulceCommercio: 'Dulce Commercio',
  dulceCommercioDescription: 'Es un proveedor externo que procesa pagos UPI para los principales sistemas de comercio electrónico.',
  dulceCommercioTarget: 'Diseñado para todos los vendedores, agentes y trabajadores remotos',
  
  // Partners section
  ourPartners: 'Nuestros Socios',
  trustedByLeading: 'Confiado por los principales mercados',
  
  // Plans
  chooseYourPlan: 'Elige Tu Plan',
  selectPlanToStart: 'Selecciona un plan para comenzar a ganar recompensas',
  yourBalance: 'Tu Saldo',
  perMonth: 'por mes',
  mealsPerDay: 'comidas por día',
  perReward: 'por recompensa',
  mostPopular: 'Más Popular',
  
  // Wallet
  myWallet: 'Mi Billetera',
  manageBalance: 'Administra tu saldo y ganancias',
  accountBalance: 'Saldo de Cuenta',
  totalEarnings: 'Ganancias Totales',
  receive: 'Recibir',
  recentTransactions: 'Transacciones Recientes',
  mealReward: 'Recompensa de Comida',
  noTransactions: 'Aún no hay transacciones',
  
  // Rewards
  myRewards: 'Mis Recompensas',
  trackRewards: 'Rastrea tus recompensas diarias y logros',
  todaysProgress: 'Progreso de Hoy',
  rewardsClaimed: 'Recompensas Reclamadas',
  currentPlan: 'Plan Actual',
  dailyLimit: 'Límite Diario',
  claimedRewards: 'Recompensas Reclamadas',
  earned: 'Ganado',
  noRewardsClaimed: 'Aún no se han reclamado recompensas',
  startClaiming: 'Comienza a reclamar recompensas probando deliciosas comidas',
  
  // Profile
  manageAccount: 'Administra tu cuenta y preferencias',
  member: 'Miembro',
  totalEarned: 'Total Ganado',
  accountSettings: 'Configuración de Cuenta',
  editProfile: 'Editar Perfil',
  notifications: 'Notificaciones',
  privacySecurity: 'Privacidad y Seguridad',
  helpSupport: 'Ayuda y Soporte',
  signOut: 'Cerrar Sesión',
  
  // Modals
  subscriptionRequired: 'Suscripción Requerida',
  subscribeToAccess: 'Suscríbete a un plan para acceder a las comidas y comenzar a ganar recompensas',
  viewPlans: 'Ver Planes',
  
  // Meal details
  mealDetails: 'Detalles de la Comida',
  nutritionFacts: 'Información Nutricional',
  calories: 'Calorías',
  protein: 'Proteína',
  carbs: 'Carbohidratos',
  fat: 'Grasa',
  quantity: 'Cantidad',
  portions: 'porciones',
  claimReward: 'Reclamar Recompensa',
  processing: 'Procesando',
  
  // Success messages
  congratulations: 'Felicidades',
  rewardClaimed: 'Recompensa Reclamada',
  youEarned: 'Has ganado',
  fromMeal: 'de la comida',
  subscriptionSuccessful: 'Suscripción Exitosa',
  successfullySubscribed: 'Te has suscrito exitosamente al plan',
  planCost: 'Costo del Plan',
  remainingBalance: 'Saldo Restante',
  startEarningRewards: 'Comenzar a Ganar Recompensas',
  
  // Withdrawal
  withdrawFunds: 'Retirar Fondos',
  availableForWithdrawal: 'Disponible para Retiro',
  enterAmount: 'Ingresa la cantidad',
  minimumWithdrawal: 'Retiro mínimo $10',
  insufficientFunds: 'Fondos insuficientes',
  withdrawalSuccessful: 'Retiro Exitoso',
  fundsTransferred: 'Los fondos han sido transferidos a tu cuenta',
  
  // Profile edit
  editYourProfile: 'Edita Tu Perfil',
  fullName: 'Nombre Completo',
  emailAddress: 'Dirección de Email',
  phoneNumber: 'Número de Teléfono',
  
  // Sign out confirmation
  signOutConfirmation: 'Confirmación de Cierre de Sesión',
  sureToSignOut: '¿Estás seguro de que quieres cerrar sesión de tu cuenta?',
  
  // Language
  language: 'Idioma',
  selectLanguage: 'Seleccionar Idioma',
  spanish: 'Español',
  english: 'Inglés',
  
  // Sistema de Referidos
  referral: 'Referidos',
  referralProgram: 'Programa de Referidos',
  inviteFriends: 'Invita Amigos y Gana',
  yourReferralCode: 'Tu Código de Referido',
  copyCode: 'Copiar Código',
  codeCopied: '¡Código Copiado!',
  shareReferralLink: 'Compartir Enlace de Referido',
  referralStats: 'Estadísticas de Referidos',
  totalReferrals: 'Total de Referidos',
  activeAgents: 'Agentes Activos',
  totalEarnings: 'Ganancias Totales',
  weeklyBonus: 'Bono Semanal',
  
  // Niveles de Recompensa
  rewardTiers: 'Niveles de Recompensa',
  guide: 'Guía',
  dulceExpert: 'Experto Dulce',
  premiumAgents: 'Agentes Premium',
  grandAgent: 'Gran Agente',
  
  // Descripciones de Niveles
  guideDesc: 'Gana $100 por cada 10 agentes activos',
  dulceExpertDesc: 'Gana $1,000 por cada 90 agentes activos',
  premiumAgentsDesc: 'Gana $5,000 por cada 450 agentes activos + $100 bono semanal',
  grandAgentDesc: 'Gana $8,000 por cada 1,000 agentes activos + $250 bono semanal',
  
  // Acciones
  inviteNow: 'Invitar Ahora',
  shareLink: 'Compartir Enlace',
  viewDetails: 'Ver Detalles',
  
  // Estado
  currentTier: 'Nivel Actual',
  nextTier: 'Siguiente Nivel',
  progress: 'Progreso',
  agentsNeeded: 'agentes necesarios',
  
  // Historial de Referidos
  referralHistory: 'Historial de Referidos',
  recentReferrals: 'Referidos Recientes',
  joinedOn: 'Se unió el',
  active: 'Activo',
  inactive: 'Inactivo',
  noReferrals: 'Aún no hay referidos',
  startInviting: 'Comienza a invitar amigos para ganar recompensas',
  
  // Mensajes para Compartir
  shareMessage: '¡Únete a mí en esta increíble plataforma y comienza a ganar! Usa mi código de referido:',
  
  // Traducciones adicionales de referidos
  referralEarnings: 'Ganancias por Referidos',
  earnUpTo: 'Gana hasta',
  perReferralTier: 'por nivel de referido',
  viewReferralProgram: 'Ver Programa de Referidos',
  agents: 'agentes',
  weekly: 'semanal',
  copyLink: 'Copiar Enlace',
  close: 'Cerrar',
  total: 'Total'
};
